import { put, takeLatest, call } from 'typed-redux-saga/macro';
import { memberApi } from '../../lib/api';
import { medInstitutionsActionTypes } from '../ducks/medical-instituitions';

function* getInstitutions() {
  try {
    const institutionsRes: any = yield* call(memberApi.getMedInstitutions);
    yield put({
      type: medInstitutionsActionTypes.GET_INSTITUTIONS_SUCCESS,
      payload: institutionsRes.data.data,
    });
  } catch {}
}

function* medicalInstitutions() {
  yield takeLatest(medInstitutionsActionTypes.GET_INSTITUTIONS_REQUEST, getInstitutions);
}

export default medicalInstitutions;
